"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Constants = void 0;
Object.defineProperty(exports, "clearSuggestedActions", {
  enumerable: true,
  get: function get() {
    return _clearSuggestedActions["default"];
  }
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _connect["default"];
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _createStore["default"];
  }
});
Object.defineProperty(exports, "createStoreWithDevTools", {
  enumerable: true,
  get: function get() {
    return _createStore.withDevTools;
  }
});
Object.defineProperty(exports, "disconnect", {
  enumerable: true,
  get: function get() {
    return _disconnect["default"];
  }
});
Object.defineProperty(exports, "dismissNotification", {
  enumerable: true,
  get: function get() {
    return _dismissNotification["default"];
  }
});
Object.defineProperty(exports, "emitTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _emitTypingIndicator["default"];
  }
});
Object.defineProperty(exports, "isForbiddenPropertyName", {
  enumerable: true,
  get: function get() {
    return _isForbiddenPropertyName["default"];
  }
});
Object.defineProperty(exports, "markActivity", {
  enumerable: true,
  get: function get() {
    return _markActivity["default"];
  }
});
Object.defineProperty(exports, "postActivity", {
  enumerable: true,
  get: function get() {
    return _postActivity["default"];
  }
});
Object.defineProperty(exports, "sendEvent", {
  enumerable: true,
  get: function get() {
    return _sendEvent["default"];
  }
});
Object.defineProperty(exports, "sendFiles", {
  enumerable: true,
  get: function get() {
    return _sendFiles["default"];
  }
});
Object.defineProperty(exports, "sendMessage", {
  enumerable: true,
  get: function get() {
    return _sendMessage["default"];
  }
});
Object.defineProperty(exports, "sendMessageBack", {
  enumerable: true,
  get: function get() {
    return _sendMessageBack["default"];
  }
});
Object.defineProperty(exports, "sendPostBack", {
  enumerable: true,
  get: function get() {
    return _sendPostBack["default"];
  }
});
Object.defineProperty(exports, "setDictateInterims", {
  enumerable: true,
  get: function get() {
    return _setDictateInterims["default"];
  }
});
Object.defineProperty(exports, "setDictateState", {
  enumerable: true,
  get: function get() {
    return _setDictateState["default"];
  }
});
Object.defineProperty(exports, "setLanguage", {
  enumerable: true,
  get: function get() {
    return _setLanguage["default"];
  }
});
Object.defineProperty(exports, "setNotification", {
  enumerable: true,
  get: function get() {
    return _setNotification["default"];
  }
});
Object.defineProperty(exports, "setSendBox", {
  enumerable: true,
  get: function get() {
    return _setSendBox["default"];
  }
});
Object.defineProperty(exports, "setSendTimeout", {
  enumerable: true,
  get: function get() {
    return _setSendTimeout["default"];
  }
});
Object.defineProperty(exports, "setSendTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _setSendTypingIndicator["default"];
  }
});
Object.defineProperty(exports, "singleToArray", {
  enumerable: true,
  get: function get() {
    return _singleToArray["default"];
  }
});
Object.defineProperty(exports, "startDictate", {
  enumerable: true,
  get: function get() {
    return _startDictate["default"];
  }
});
Object.defineProperty(exports, "startSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _startSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "stopDictate", {
  enumerable: true,
  get: function get() {
    return _stopDictate["default"];
  }
});
Object.defineProperty(exports, "stopSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _stopSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "submitSendBox", {
  enumerable: true,
  get: function get() {
    return _submitSendBox["default"];
  }
});
exports.version = void 0;
Object.defineProperty(exports, "warnOnce", {
  enumerable: true,
  get: function get() {
    return _warnOnce["default"];
  }
});

var ActivityClientState = _interopRequireWildcard(require("./constants/ActivityClientState"));

var DictateState = _interopRequireWildcard(require("./constants/DictateState"));

var _clearSuggestedActions = _interopRequireDefault(require("./actions/clearSuggestedActions"));

var _connect = _interopRequireDefault(require("./actions/connect"));

var _createStore = _interopRequireWildcard(require("./createStore"));

var _disconnect = _interopRequireDefault(require("./actions/disconnect"));

var _dismissNotification = _interopRequireDefault(require("./actions/dismissNotification"));

var _emitTypingIndicator = _interopRequireDefault(require("./actions/emitTypingIndicator"));

var _isForbiddenPropertyName = _interopRequireDefault(require("./utils/isForbiddenPropertyName"));

var _markActivity = _interopRequireDefault(require("./actions/markActivity"));

var _postActivity = _interopRequireDefault(require("./actions/postActivity"));

var _sendEvent = _interopRequireDefault(require("./actions/sendEvent"));

var _sendFiles = _interopRequireDefault(require("./actions/sendFiles"));

var _sendMessage = _interopRequireDefault(require("./actions/sendMessage"));

var _sendMessageBack = _interopRequireDefault(require("./actions/sendMessageBack"));

var _sendPostBack = _interopRequireDefault(require("./actions/sendPostBack"));

var _setDictateInterims = _interopRequireDefault(require("./actions/setDictateInterims"));

var _setDictateState = _interopRequireDefault(require("./actions/setDictateState"));

var _setLanguage = _interopRequireDefault(require("./actions/setLanguage"));

var _setNotification = _interopRequireDefault(require("./actions/setNotification"));

var _setSendBox = _interopRequireDefault(require("./actions/setSendBox"));

var _setSendTimeout = _interopRequireDefault(require("./actions/setSendTimeout"));

var _setSendTypingIndicator = _interopRequireDefault(require("./actions/setSendTypingIndicator"));

var _singleToArray = _interopRequireDefault(require("./utils/singleToArray"));

var _startDictate = _interopRequireDefault(require("./actions/startDictate"));

var _startSpeakingActivity = _interopRequireDefault(require("./actions/startSpeakingActivity"));

var _stopDictate = _interopRequireDefault(require("./actions/stopDictate"));

var _stopSpeakingActivity = _interopRequireDefault(require("./actions/stopSpeakingActivity"));

var _submitSendBox = _interopRequireDefault(require("./actions/submitSendBox"));

var _warnOnce = _interopRequireDefault(require("./utils/warnOnce"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Constants = {
  ActivityClientState: ActivityClientState,
  DictateState: DictateState
};
exports.Constants = Constants;
var version = "4.15.7";
exports.version = version;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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